import { render, staticRenderFns } from "./VeeAutocomplete.vue?vue&type=template&id=35145202&"
import script from "./VeeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VeeAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports